import { render, staticRenderFns } from "./LastHand.vue?vue&type=template&id=49d78cac&scoped=true&"
import script from "./LastHand.vue?vue&type=script&lang=js&"
export * from "./LastHand.vue?vue&type=script&lang=js&"
import style0 from "./LastHand.vue?vue&type=style&index=0&id=49d78cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d78cac",
  null
  
)

export default component.exports